import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { RouteExact } from '../../../../../mission/models/Route';
import { kmToMiles, kmToNauticalMiles } from '../../../../../common/utils/converter';

const RouteTreeView = ({ routes, setRoutes, setCenteredGeometries, disabled }) => {
  const handleRoutesCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(routes, item.id));
    },
    [routes, setCenteredGeometries]
  );

  const handleRoutesVisibilityClick = useCallback(
    (item, isToggled) => {
      setRoutes((oldRoutes) => getEntitiesWithVisibility(oldRoutes, item.id, isToggled));
    },
    [setRoutes]
  );

  const { current: routeItemActions } = useRef([
    { id: 'route-center', icons: { default: 'gps_fixed' }, onClick: handleRoutesCenterClick },
    {
      id: 'route-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleRoutesVisibilityClick,
    },
  ]);

  const routeItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('mission.details.routes')}: ${routes.length}`,
        actions: routeItemActions,
        children: routes.map((route, index) => ({
          id: index,
          label: `${route.name}: ${kmToMiles(route.lengthInKilometers).toFixed(2)} mi (${kmToNauticalMiles(route.lengthInKilometers).toFixed(2)}) nm`,
          actions: routeItemActions,
          disabled,
        })),
        disabled,
      },
    ],
    [routes, routeItemActions, disabled]
  );

  return <TreeView id="routes" items={routeItems} />;
};

RouteTreeView.propTypes = {
  routes: PropTypes.arrayOf(RouteExact),
  setRoutes: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RouteTreeView.defaultProps = {
  routes: [],
  disabled: false,
};

export default RouteTreeView;
